import { FC } from 'react';
import { DashboardSidebarSubNavigation } from '@cbridge-modules/sidebar';
import { useConfigSymbolsNavigationItems, RouteSegments } from '@cbridge-packages/routing-client-admin';

export const SymbolsNavigation: FC = () => {
  const symbolsNavigation = useConfigSymbolsNavigationItems();

  return (
    <DashboardSidebarSubNavigation
      items={symbolsNavigation}
      variant={'secondary'}
      basePath={`/${RouteSegments.Root.Config}`}
      isMini={false}
      isFullyExpanded={true}
    />
  );
};
